import React, { useContext } from 'react';

interface TableRowContextProps {
  expandedViewId?: string;
}

export const TableRowContext = React.createContext<TableRowContextProps | null>(
  null
);

export function useTableRowContext(): TableRowContextProps {
  const context = useContext(TableRowContext);
  if (context) {
    return context;
  }
  throw new Error(
    'TableRow context can only be used within Table.Row component.'
  );
}
